"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconReinsurancePayment = void 0;
var React = __importStar(require("react"));
var IconReinsurancePayment = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M18.5,18 C20.43,18 22,16.43 22,14.5 C22,12.57 20.43,11 18.5,11 C16.57,11 15,12.57 15,14.5 C15,16.43 16.57,18 18.5,18 Z M2,16.453 C2,16.755 2.233,17 2.52,17 L14.762,17 C14.281,16.284 14,15.425 14,14.5 C14,13.079 14.675,11.825 15.706,11 L2,11 L2,16.453 Z M2.52,7 C2.233,7 2,7.245 2,7.547 L2,9 L18,9 L18,7.547 C18,7.245 17.767,7 17.48,7 L2.52,7 Z M19,10.051 C21.244,10.303 23,12.189 23,14.5 C23,16.981 20.981,19 18.5,19 C17.439,19 16.477,18.616 15.706,18 L2.52,18 C1.682,18 1,17.306 1,16.453 L1,7.547 C1,6.694 1.682,6 2.52,6 L17.48,6 C18.318,6 19,6.694 19,7.547 L19,10.051 Z M17.75,13.6152 L17.75,14.0002 L19.25,14.0002 L19.25,13.6152 C19.25,13.5262 19.226,12.7502 18.5,12.7502 C17.774,12.7502 17.75,13.5262 17.75,13.6152 Z M19.75,13.6152 L19.75,14.0002 L20,14.0002 L20,15.8942 C20,16.1752 19.94,16.4412 19.55,16.4412 L17.45,16.4412 C17.135,16.4412 17,16.2902 17,15.8942 L17,14.0002 L17.25,14.0002 L17.25,13.6152 C17.25,13.1422 17.512,12.2502 18.5,12.2502 C19.488,12.2502 19.75,13.1422 19.75,13.6152 Z M3,14 L3,13 L11,13 L11,14 L3,14 Z M3,16 L3,15 L9,15 L9,16 L3,16 Z" }))); };
exports.IconReinsurancePayment = IconReinsurancePayment;
exports.IconReinsurancePayment.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconReinsurancePayment;
